import { KURALA_GORE_IADE_EVENT_EKLE } from "../constants/requestUrls";

import { postRequest } from "../request";

const kuralaGoreIadeEventEkle = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  console.log(data);
  return postRequest({ url: KURALA_GORE_IADE_EVENT_EKLE, data });
}

export default kuralaGoreIadeEventEkle;